var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96826 0.500017C7.09979 0.499256 7.23019 0.524468 7.35196 0.574207C7.47374 0.623947 7.5845 0.697234 7.67789 0.789867L13.6748 6.78679C13.863 6.975 13.9688 7.23026 13.9688 7.49642C13.9688 7.76259 13.863 8.01785 13.6748 8.20606C13.4866 8.39427 13.2313 8.5 12.9652 8.5C12.699 8.5 12.4437 8.39427 12.2555 8.20606L6.96826 2.90878L1.68097 8.19606C1.48977 8.35981 1.24382 8.44537 0.992271 8.43565C0.740725 8.42594 0.502107 8.32166 0.324104 8.14365C0.146101 7.96565 0.0418235 7.72703 0.0321074 7.47549C0.0223914 7.22394 0.107952 6.97799 0.271694 6.78679L6.26861 0.789867C6.45478 0.605218 6.70605 0.501121 6.96826 0.500017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.4b85ef716174a6273844192a7012aaa5.svg";
export { ForwardRef as ReactComponent };